export enum ViewCommentParentType {
  keyResult,
  topicDraft,
  objective,
}
